interface PaginationRequest {
  pageSize: number;
  nextToken?: string;
}

interface PaginatedPage<T> {
  items?: readonly T[];
  nextToken?: string;
}

export const callApiWithPagination = async <T>(
  pageSize: number,
  callPage: (request: PaginationRequest) => Promise<PaginatedPage<T>>
): Promise<T[]> => {
  const allItems: T[] = [];
  const seenTokens = new Set<string>();
  let nextToken: string | undefined;

  do {
    const response = await callPage({ pageSize, nextToken });
    allItems.push(...(response.items ?? []));
    nextToken = response.nextToken;

    if (nextToken) {
      if (seenTokens.has(nextToken)) {
        throw new Error(`Paginated API returned repeated token: ${nextToken}`);
      }
      seenTokens.add(nextToken);
    }
  } while (nextToken);

  return allItems;
};
